import { render } from "./LGBudgetReport.vue?vue&type=template&id=50a8951e&ts=true&lang=pug"
import script from "./LGBudgetReport.vue?vue&type=script&lang=ts"
export * from "./LGBudgetReport.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__